const PropositionEntity = (backClient) => ({
  index: async (params) => {
    Object.keys(params).forEach((key) => !params[key] && delete params[key])
    return await backClient.get(`/api/simulations/propositions`, { params })
  },
  propositionLevers: async (params) => {
    Object.keys(params).forEach((key) => !params[key] && delete params[key])
    return await backClient.get(`/api/simulations/proposition_levers`, {
      params,
    })
  },
  propositionKpis: async (params) => {
    Object.keys(params).forEach((key) => !params[key] && delete params[key])
    return await backClient.get(`/api/simulations/proposition_kpis`, { params })
  },
})

export default PropositionEntity
